import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import 'xterm/css/xterm.css'

import App from './App.vue';
import vuetify from './plugins/vuetify';
import * as axios from './plugins/axios'
import router from './router';

Vue.config.productionTip = false

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
extend('email', email);
extend('required', required);

new Vue({
  vuetify,
  axios,
  router,
  render: h => h(App)
}).$mount('#app');
